import React from "react";

const ProjectCount = () => {
  return (
    <section className="gredirnt_count_sec">
      <div className="container">
        <div className="count_outer">
          <div className="row justify-content-center">
            <div className="col-lg-4 col-sm-6 mb-4">
              <div className="count_item text-center">
                <h3 className="text-white fs-xl mb-2 text-uppercase">+100</h3>
                <p className="fs-sm text-white">
                  Investment firms, business angels, venture, capital...
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 mb-4">
              <div className="count_item text-center">
                <h3 className="text-white fs-xl mb-2 text-uppercase">+100</h3>
                <p className="fs-sm text-white">
                  Leaders of the startup ecosystem present
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 mb-4">
              <div className="count_item text-center">
                <h3 className="text-white fs-xl mb-2 text-uppercase">+100</h3>
                <p className="fs-sm text-white">
                  Leading international and national, speakers and institutions
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 mb-4">
              <div className="count_item text-center">
                <h3 className="text-white fs-xl mb-2 text-uppercase">+30</h3>
                <p className="fs-sm text-white">
                  Startup and Innovation Partnerships Invited
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 mb-4">
              <div className="count_item text-center">
                <h3 className="text-white fs-xl mb-2 text-uppercase">
                  + €500 million
                </h3>
                <p className="fs-sm text-white">
                  of private investment capacity present
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectCount;
